import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../../Components/NavigationLayout";
import Edit from "./Edit";

const Worldwide = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/hotlines/worldwide" component={List} />
        <Route path="/admin/hotlines/worldwide/new" component={Add} />
        <Route path="/admin/hotlines/worldwide/:id" component={Edit} />
      </Switch>
    </Router>
  );
};
export default Worldwide;
